<div class="florder-select-customer">
  <form class="customerForm" [formGroup]="customerForm">
    <ng-container>
      <eps-select
        label="ORDERS.CUSTOMER.LABELS.CUSTOMER"
        [options]="customers"
        bindAsObject
        autoSelect
        [labelWidth]="labelWidth"
        formControlName="customer"
        [readonly]="!panelStatus.isEdit"
        [showErrors]="panelStatus.isEdit"
      ></eps-select>

      <div class="buttons" *ngIf="panelStatus.isEdit">
        <eps-button
          type="link"
          *ngIf="panelStatus.isNew"
          (buttonClick)="cancelClicked.emit()"
          label="SHARED.BUTTONS.CANCEL"
        ></eps-button>
        <eps-button
          [disabled]="!customerForm.valid"
          (buttonClick)="doNextClicked()"
          buttonIcon="check"
          [label]="panelStatus.isNew ? 'FLOWS.DETAILS.BUTTONS.NEXT' : 'SHARED.BUTTONS.SAVE'"
          submit
        ></eps-button>
      </div>
    </ng-container>
  </form>
</div>
